import React from 'react';

import { useAppSelector } from 'redux/hooks';
import { getSearchParams } from 'utils/locationHelper';

const withParamsFrame = (Component: React.FC<{params: string}>) => () => {

    const { accessToken, currentLanguage } = useAppSelector(({ users, appOptions }) => ({
        accessToken: users.currentUser.data.accessToken,
        currentLanguage: appOptions.language
    }))

    const getParametrs = getSearchParams(window.location.href);
    const spaAuthParam = `_spa_auth=${accessToken}`;
    const scopeParam = `_spa_scope=breadcrumbs`;
    const localeParam = `_locale=${currentLanguage.current}`;
    const params = getParametrs?.length > 0 ? `?${getParametrs}&${localeParam}&${scopeParam}&${spaAuthParam}` : `?${localeParam}&${scopeParam}&${spaAuthParam}`;

    return <Component params={params} />
}

export default withParamsFrame;